/* eslint-disable import/no-anonymous-default-export */
import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_GAMES,
    QR_SESSION_LOGIN,
    UPDATE_USER_EMAIL,
    IMPERSONATE_LOGIN,
    IMPERSONATE_LOGOUT,
    SESSION_ENDED,
    SESSION_ENDED_CLEAR,
    SESSION_CONFLICT,
    SESSION_CONFLICT_CLEAR,

} from "actions/types";

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};

let initialLoggedInState = false;
let initialIsImpersonated = false;

let user = JSON.parse(localStorage.getItem("user")) || null;

if (user) {
    const decodedJwt = parseJwt(user.token);
    if (decodedJwt.exp * 1000 > Date.now()) {
        initialLoggedInState = true;
        // Check if this is an impersonated session
        initialIsImpersonated = user.isImpersonated === true;
    } else {
        user = null;
    }
}

const initialState = { isLoggedIn: initialLoggedInState, user, isImpersonated: initialIsImpersonated, sessionEndedMessage: null, sessionConflict: null };

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case REGISTER_SUCCESS:
            return {
                ...state,
                isLoggedIn: false,
            };
        case REGISTER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: payload.user,
                sessionEndedMessage: null,
                sessionConflict: null,
            };
        case LOGIN_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                sessionEndedMessage: null,
                sessionConflict: null,
            };
        case SET_GAMES:
            return {
                ...state,
                user: payload
            };
        case QR_SESSION_LOGIN:
            return {
                ...state,
                isLoggedIn: true,
                user: payload.user,
                sessionEndedMessage: null,
                sessionConflict: null,
            }
        case UPDATE_USER_EMAIL:
            return {
                ...state,
                user: state.user ? {
                    ...state.user,
                    email: payload.email,
                    token: payload.token,
                    userName: payload.userName,
                } : null,
            };
        case IMPERSONATE_LOGIN:
            return {
                ...state,
                isLoggedIn: true,
                isImpersonated: true,
                user: payload.user,
                sessionEndedMessage: null,
                sessionConflict: null,
            };
        case IMPERSONATE_LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                isImpersonated: false,
                user: null,
                sessionEndedMessage: null,
                sessionConflict: null,
            };
        case SESSION_ENDED:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                sessionEndedMessage: payload?.message || "You've been logged out because your account was signed in elsewhere. Only 1 active session is allowed at a time.",
            };
        case SESSION_ENDED_CLEAR:
            return {
                ...state,
                sessionEndedMessage: null,
            };
        case SESSION_CONFLICT:
            return {
                ...state,
                sessionConflict: {
                    message: payload.message,
                    activeSessions: payload.activeSessions,
                },
            };
        case SESSION_CONFLICT_CLEAR:
            return {
                ...state,
                sessionConflict: null,
            };
        default:
            return state;
    }
}
